import { computed } from 'vue';
import { ModalStatusLoadingEnums } from '@/models/modal-status-loading-enum';
import RedshiftTracker from '@/infrastructure/redshift-tracker';
import store from '@/store';

export default class ClientReviewOverviewComponent {
	public modalStatusLoadingIsInactive = computed((): boolean => {
		return store.getters.modalStatusLoading() === ModalStatusLoadingEnums.INACTIVE;
	});

	public organisationName = computed((): string => {
		const selectedPartnership = store.getters.selectedPartnership();
		return selectedPartnership.organisationName;
	});

	private get redshiftTracker(): RedshiftTracker {
		return store.state.redshiftTracker;
	}

	public mounted(): void {
		this.redshiftTracker.trackInitialLoadingSpeed(false);
	}
}
